import { Component, OnInit, Input } from "@angular/core";
import { DashboardService } from "../dashboard.service";
import { TeamResult } from "../dashboard.model";
import { CorpClient } from "src/app/shared-models/client.model";
import { CorpClientsService } from "src/app/corp-clients.service";
import { Auth } from "aws-amplify";
import { UsersService } from "src/app/users/users.service";

@Component({
    selector: "dashboard-team-results",
    templateUrl: "./team-results.component.html",
    styleUrls: ["./team-results.component.css"],
    standalone: false
})
export class TeamResultsComponent implements OnInit {
  isLoading = false;
  error: string;
  result: TeamResult;

  currentClient: CorpClient;

  private _days: number = 90;
  @Input("days")
  set days(value: number) {
    this._days = value;
    this.getTeamResults();
  }
  get days(): number {
    return this._days;
  }

  constructor(
    private api: DashboardService,
    private corpService: CorpClientsService,
    private userService: UsersService
  ) {
    this.corpService.currentClient.subscribe((result) => {
      if (result == null) {
        return;
      }
      this.currentClient = result;
      this.getTeamResults();
    });
  }

  ngOnInit() {}

  async getTeamResults() {
    const cognitoUser = await Auth.currentAuthenticatedUser();
    let payload = cognitoUser.getSignInUserSession().getAccessToken().decodePayload();
    const isAdmin = await this.userService.isAuthenticatedUserClientAdmin();

    if (!isAdmin) {
      let cognitoUser = await Auth.currentAuthenticatedUser();
      cognitoUser.getUserAttributes((err, result) => {
        let clientId = result
          .filter((item) => item.getName() == "custom:client_id")
          .map((att) => att.getValue())[0]
          .toString();

        this.api
          .getStdUserResults(this.days, clientId)
          .then((response) => {
            this.result = <TeamResult>response.value[0][0];
          })
          .catch((error) => {
            console.log(error);
            this.error = "Could not load chart data at this time.";
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    } else {
      this.error = null;
      this.isLoading = true;

      this.api
        .getTeamResults(this.days, this.currentClient.client_id)
        .then((response) => {
          this.result = <TeamResult>response.value[0][0];
        })
        .catch((error) => {
          console.log(error);
          this.error = "Could not load chart data at this time.";
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
}
